import { type ApolloError, useSubscription } from '@apollo/client'

import logger from '@/utils/logger'

import { useIsPageVisible } from '@/client/hooks'
import type {
  ManageBreakoutSessionsSubscription,
  ManageBreakoutSessionsSubscriptionVariables,
} from '@/client/services/hasura/generated/graphql'

import { MANAGE_BREAKOUT_SESSIONS_SUBSCRIPTION } from './useRealtimeManageBreakoutSessions.hasura'

export default function useRealtimeManageBreakoutSessions(sessionId: number): {
  loading: boolean
  error: ApolloError | null
  session: ManageBreakoutSessionsSubscription['session_by_pk']
} {
  const isPageVisible = useIsPageVisible()

  const { loading, error, data } = useSubscription<
    ManageBreakoutSessionsSubscription,
    ManageBreakoutSessionsSubscriptionVariables
  >(MANAGE_BREAKOUT_SESSIONS_SUBSCRIPTION, {
    variables: { sessionId },
    onError: err => {
      logger.warning('Error querying Hasura for session breakout registrations', { err })
    },
    skip: !isPageVisible,
  })

  return {
    loading,
    error: error ?? null,
    session: data?.session_by_pk ?? null,
  }
}
